import React, { useRef, useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Section, TextColumn, Automec, TextoAbaixo } from './../styles/styles';
import produto1 from './../styles/product.png'
import produto2 from './../styles/product2.png'
import produto3 from './../styles/product3.png'
import produto4 from './../styles/product4.png'
import produto5 from './../styles/product5.png'


const conteudos = [
    {
        titulo: "Overview",
        desc: [
          {
            text: " This project involved a critical intervention to correct a major manufacturing error in the Tool Kit EVA foam inserts. Due to incorrect die-lines from the overseas supplier, the tools didn't fit properly. Working alongside a product specialist, I led the technical redesign of the cutting lines to ensure a perfect fit and meet a high-pressure launch deadline. "
          },
          {
            title: "ROLE:",
            text: "Product Designer"
          },
          {
            title: "RESPONSIBILITIES:",
            text: "Silhouette Drafting, Illustrator Die-line Creation, Rapid Prototyping, and Supplier Communication."
          }
        ],
        img: produto1
      },
       {
        titulo: "Challenge",
        desc: [
          {
            text: " The original EVA inserts produced in China failed to secure the tools, risking the entire product launch. We had a strict two-week window to redesign, test, and produce 50 corrected units locally before the official sale date, while also providing the factory with foolproof files for future production."
          },  
        ],
        img: produto2
      },
      {
        titulo: "Solution",
        desc: [
          {
            title: "Precision Silhouetting:",
            text: "Precision Silhouetting: Hand-drafted and digitized the exact silhouette of each individual tool to create a custom-fit map."
          },
          {
            title: "Grid Systems:",
            text: "Establishing a rigid structure for text hierarchy and element organization."
          },
          {
            title: "Iterative Prototyping:",
            text: "Developed 3 distinct technical iterations for each tool's cutting line in Adobe Illustrator, testing for friction fit and ease of access."
          }
        ],
        img: produto3
      },
      {
        titulo: "Solution",
        desc: [
          {
            title: "Agile Collaboration::",
            text: "Worked in a tight feedback loop with the production team to laser-cut and test prototypes in real-time, drastically reducing development cycles."
          },
          {
            title: "Global Standardization:",
            text: "Created a new, standardized die-line master file to be sent back to the Chinese manufacturer, ensuring all future batches adhere to the corrected dimensions."
          },
        ],
        img: produto4
      },
      {
        titulo: "Results",
        desc: [
          {
            title: "Efficiency:",
            text: "Legacy workflows were transformed into an organized and scalable production system."
          },
          {
            title: "Output:",
            text: "Over 400 visual assets were produced, including 3D models, renders, and photography."
          },
          {
            title: "Growth:",
            text: "Deep expertise in brand strategy and technical coordination was developed."
          },
          {
            title: "Standardization:",
            text: "A unified file structure was created, giving the team clarity and flexibility for future campaigns."
          }
        ],
        img: produto5
      }
    ];

const ProjetoProduct = () => {
  const containerRef = useRef(null);
  const [dragWidth, setDragWidth] = useState(0);

  useEffect(() => {
    const calcularWidth = () => {
      if (!containerRef.current) return;

      const scrollWidth = containerRef.current.scrollWidth;
      const offsetWidth = containerRef.current.offsetWidth;

      setDragWidth(scrollWidth - offsetWidth);
    };

    calcularWidth();
    window.addEventListener('resize', calcularWidth);

    return () => window.removeEventListener('resize', calcularWidth);
  }, []);

  return (
    <div
      ref={containerRef}
      style={{
        width: "100%",
        overflow: "hidden",
        position: "relative",
      }}
    >
      <motion.div
        drag="x"
        dragConstraints={{ left: -dragWidth, right: 0 }}
        dragElastic={0.1}
        dragMomentum={false}
        style={{
          display: "flex",
          width: "max-content",
          cursor: "grab",
        }}
        whileTap={{ cursor: "grabbing" }}
      >
        {conteudos.map((item, index) => (
          <Section
            key={index}
            style={{
              width: "1500",
              flexShrink: 0,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              paddingLeft: "40px",
              boxSizing: "border-box",
            }}
          >
            <img
              src={item.img}
              alt={item.titulo}
              draggable={false}
              style={{
                width: "auto",
                height: "70vh",
                marginLeft: "200px",
                pointerEvents: "none",
                userSelect: "none",
                borderRadius: "20px",
              }}
            />
            <TextColumn>
              <Automec>{item.titulo}</Automec>

              <TextoAbaixo>
                {item.desc.map((bloco, i) => (
                  <p key={i}>
                    {bloco.title && <strong>{bloco.title}</strong>} {bloco.text}
                  </p>
                ))}
              </TextoAbaixo>
            </TextColumn>
          </Section>
        ))}
      </motion.div>
    </div>
  );
};

export default ProjetoProduct;